import codeBooksModalLogic from "./codeBooksModal";
import gridLogic from "./codeGrid";
import drgAnalyzeLogic from "./drgAnalyze";
import encounterLogic from "./encounter";
import logoutCurrentUserLogic from "./logout";

export default [
  ...codeBooksModalLogic,
  ...encounterLogic,
  ...drgAnalyzeLogic,
  ...gridLogic,
  ...logoutCurrentUserLogic,
];
